import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as o from "react";
import { c } from "./index.CxSWpsOB.js";
const m = () => /* @__PURE__ */ t.jsx("span", { "aria-hidden": "true", className: "tw-relative -tw-top-2 tw-mx-8 tw-inline-block tw-size-2 tw-rounded-circular tw-bg-gray-900 tw-align-middle" }), p = ({
  items: e,
  separator: a,
  className: l,
  testId: n
}) => {
  if (e.length === 0) return null;
  const r = a ?? /* @__PURE__ */ t.jsx(m, {});
  return /* @__PURE__ */ t.jsx("span", { "data-slot": "inline-bullets", "data-testid": n, className: c(l), children: e.map((i, s) => /* @__PURE__ */ t.jsxs(o.Fragment, { children: [
    s > 0 && r,
    i
  ] }, s)) });
};
export {
  p as I
};
//# sourceMappingURL=InlineBullets.BoW_Cy1W.js.map
